export default "__VITE_ASSET__CCKQZ3HT__"